module.exports = __webpack_public_path__ + "img/DCIcase.4baa2f63.png";